"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import React from "react";

// JSON data at top and bound to UI
const WIN_DATA = {
  title: "வெற்றி நிகழ்ச்சவு",
  leftTeam: {
    name: "மும்பை இந்தியன்ஸ்",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    logoBg: "#2376FF"
  },
  rightTeam: {
    name: "சன் ரைசர்ஸ் ஹைதராபாத்",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    logoBg: "#F59E0B"
  },
  percentLeft: 52,
  percentRight: 48
};
export default function IplWindRange(t0) {
  const $ = _c(7);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = "w-full text-[#1B2329] " + className;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minHeight: 113,
      backgroundImage: "url(https://media.dinamani.com/dinamani/2026-02-27/44zovmyz/winbackground.png)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-center text-14-tamil-700 text-012061 flex items-center justify-center">{WIN_DATA.title}</div>;
    t5 = <div className="mt-2 border-t border-909090B" />;
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center justify-between lg:pe-4 pe-0 lg:border-e border-909090B"><div><TeamBlock name={WIN_DATA.leftTeam.name} logo={WIN_DATA.leftTeam.logo} bg={WIN_DATA.leftTeam.logoBg} align="left" /></div><div className="text-14-english-600 justify-end flex text-1B1B1B">{WIN_DATA.percentLeft}%</div></div>;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="px-3 md:px-6 py-3 flex flex-col h-full gap-4">{t4}{t5}<div className="grid lg:grid-cols-2 grid-cols-1 justify-center gap-4">{t6}<div className="flex flex-row-reverse lg:flex-row items-center justify-between lg:ps-4 ps-0"><div className="text-14-english-600 text-1B1B1B">{WIN_DATA.percentRight}%</div><TeamBlock name={WIN_DATA.rightTeam.name} logo={WIN_DATA.rightTeam.logo} bg={WIN_DATA.rightTeam.logoBg} align="right" /></div></div></div>;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t2) {
    t8 = <div className="p-4"><div className={t2} style={t3}>{t7}</div></div>;
    $[5] = t2;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
}
function TeamBlock(t0) {
  const $ = _c(15);
  const {
    name,
    logo,
    bg,
    align
  } = t0;
  const t1 = "flex items-center gap-3 max-w-full " + (align === "right" ? "sm:flex-row-reverse" : "");
  let t2;
  if ($[0] !== bg) {
    t2 = {
      width: "44px",
      height: "44px",
      backgroundColor: bg
    };
    $[0] = bg;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== logo || $[3] !== name) {
    t3 = <Image src={logo} alt={name} width={32} height={32} className="object-contain" />;
    $[2] = logo;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="rounded-[5px] flex items-center justify-center overflow-hidden" style={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = "text-14-tamil-700 truncate max-w-[60vw] sm:max-w-[260px] text-1B1B1B" + (align === "right" ? "text-right" : "");
  let t6;
  if ($[8] !== name || $[9] !== t5) {
    t6 = <div className={t5}>{name}</div>;
    $[8] = name;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t4 || $[13] !== t6) {
    t7 = <div className={t1}>{t4}{t6}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}